import Image from "next/image";
import logoUrl from "@/assets/communo-logo.png";

type LogoProps = {
  className?: string;
};

const Logo = ({ className = "h-8 w-auto" }: LogoProps) => {
  return (
    <div className={className}>
      <Image 
        src={logoUrl} 
        alt="Communo" 
        width={160} 
        height={40} 
        style={{ height: '100%', width: 'auto' }}
        priority 
      />
    </div>
  );
};

export default Logo;
